// Central GSAP configuration - import this file instead of 'gsap' directly
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';

// Use window.gsap if available (from CDN), otherwise use imported gsap
const gsapInstance = (typeof window !== 'undefined' && window.gsap) ? window.gsap : gsap;

// Register all plugins
gsapInstance.registerPlugin(ScrollTrigger, SplitText);

// Ensure global gsap uses the same instance and plugins (WP may enqueue GSAP separately)
if (typeof window !== 'undefined') {
  // Use CDN version if available
  if (window.gsap) {
    window.gsap.registerPlugin(ScrollTrigger, SplitText);
  } else {
    window.gsap = gsapInstance;
  }

  window.ScrollTrigger = ScrollTrigger;
  window.SplitText = SplitText;

  // Register MotionPathPlugin if loaded from CDN
  if (window.MotionPathPlugin) {
    gsapInstance.registerPlugin(window.MotionPathPlugin);
    if (window.gsap) {
      window.gsap.registerPlugin(window.MotionPathPlugin);
    }
  }
}

// Export configured gsap and plugins
export { gsapInstance as gsap, ScrollTrigger, SplitText };
export default gsapInstance;
